import { ref, readonly } from 'vue';
import { getCartCount } from '@/api/cart';

// 购物车数量响应式状态
const cartCount = ref(0);

/**
 * 获取购物车数量（只读）
 */
export const useCartCount = () => readonly(cartCount);

/**
 * 刷新购物车数量
 */
export const refreshCartCount = async () => {
  try {
    const res = await getCartCount();
    if (res.code === 200) {
      cartCount.value = res.data || 0;
    }
  } catch (error) {
    console.error('获取购物车数量失败:', error);
  }
};

/**
 * 设置购物车数量（用于本地更新）
 */
export const setCartCount = (count: number) => {
  cartCount.value = count;
};

/**
 * 增加购物车数量
 */
export const incrementCartCount = (delta: number = 1) => {
  cartCount.value += delta;
};
